// The three sponsor asks Peter described on the Nov 2 call, so the Lists page has real work on day one.
import { fromSharedAsk, type Ask } from "../../shared/lists-engine";

export const STARTER_ASKS: Ask[] = [
  {
    ask_id: "A-VALKYRIE",
    requester: "Valkyrie (Austin, TX)",
    received: "2026-11-02",
    ask: "Raising for an eVTOL (vertical takeoff and landing) aircraft program. Who in your network would want to look at this?",
    target_sectors: ["Aerospace & Defense", "Industrials & Manufacturing"],
    target_types: ["Family office", "UHNW individual", "PE fund GP"],
    min_check: 250000,
    list_size: 40,
  },
  {
    ask_id: "A-LEA",
    requester: "Legal Enterprises Holdings (Brandon)",
    received: "2026-10-30",
    ask: "Legal services MSO roll-up. Peter declined to raise it himself but could hand over a curated list of people with interest.",
    target_sectors: ["Legal & Professional Services", "Business Services"],
    min_check: 250000,
    list_size: 25,
  },
  {
    ask_id: "A-SANDIEGO",
    requester: "Friend hosting an investor dinner in San Diego",
    received: "2026-10-20",
    ask: "Pull all my contacts in Southern California / the Southwest so the host can send invitations.",
    target_regions: ["West Coast", "Southwest"],
    target_states: ["CA", "AZ"],
    list_size: 150,
  },
].map(fromSharedAsk);
